module.exports = __webpack_public_path__ + "5d7eb25153b4e1964f4284002020de21.png";